const wappstoVariables = {
  primary: '#1f324d',
  secondary: '#0094fa',
  accent: '#f7b40d',
  bg: '#f5f5f5',
  white: '#ffffff',
  border: '#d9d9d9',
  text: '#222222',
  testInverse: 'rgba(255, 255, 255, 0.65)',
  fontFamily:
    'Roboto, Helvetica, Arial, sans-serif, -apple-system, Segoe UI, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol',
  fontSM: 12,
  fontMD: 14,
  fontLG: 16,
};

export const antThemeLight = {
  token: {
    colorPrimary: wappstoVariables.secondary,
    colorPrimaryBg: wappstoVariables.bg,
    colorBgBase: wappstoVariables.white,
    colorText: wappstoVariables.text,
    colorLink: wappstoVariables.secondary,
    fontFamily: wappstoVariables.fontFamily,
    borderRadius: 3,
    colorBorder: wappstoVariables.border,
    fontSizeSM: wappstoVariables.fontSM,
    fontSize: wappstoVariables.fontMD,
    fontSizeLG: wappstoVariables.fontLG,
    colorTextHeading: wappstoVariables.primary,
  },
  components: {
    Layout: {
      headerBg: wappstoVariables.white,
      bodyBg: wappstoVariables.bg,
    },
    Menu: {
      colorPrimary: 'rgba(0, 148, 250, 0.5)',
      itemHeight: 48,
    },
    Dropdown: {
      colorBgContainer: 'red',
    },
    Form: {
      paddingXS: 2,
      paddingSM: 6,
      margin: 12,
      marginLG: 18,
    },
    Tooltip: { colorBgSpotlight: wappstoVariables.primary },
  },
};
